export default {
	project: {
		my_xs: 'Meine Entscheidungen',
		fields: {
			name: 'Titel',
			name_explanation: 'Geben Sie einen Titel für Ihr Projekt an',
			description: 'Mission',
			description_explanation: 'Definieren Sie Ihre Gesamtmission',
			vision: 'Vision',
			vision_explanation: 'Definieren Sie die langfristige Vision des Projekts',
			description_long: 'Beschreibung',
			description_long_explanation: 'Z. B.: «Schweizer KMU für Mechatronik, 200 Mitarbeitende, europäischer Automobil-OEM-Markt. Mission: bis 2030 europäischer Marktführer für intelligente Sensoren werden.»',
			description_long_hint: 'Je präziser die Beschreibung (Branche, Größe, Mission), desto genauer die Analyse.',
			description_long_warning_title: 'Knappe Beschreibung',
			description_long_warning_body: 'Ihre Beschreibung umfasst {{count}} Zeichen. Die KI könnte eine Branche oder einen Kontext annehmen, der nicht zu Ihrer Organisation passt. Möchten Sie sie vor dem Start anreichern?',
			description_long_warning_enrich: 'Anreichern',
			description_long_warning_continue: 'Trotzdem starten',
			ai_context: 'Spezifischer Fokus und Blickwinkel',
			ai_context_explanation: 'Geben Sie die Blickwinkel, Akteure oder Rahmenbedingungen an, die die Analyse priorisieren soll (z. B. ein bestimmter Wettbewerber, eine regulatorische Dimension, ein Gebiet, eine zeitliche Vorgabe…).',
			fishbone_description: 'Strategischer Plan - Zu sein',
			fishbone_description_explanation: '',
			reference: 'Referenz',
			tags: 'Tags',
			likelihoods: 'Wahrscheinlichkeiten',
			impacts: 'Auswirkungen',
			types: {
				stakeholders: 'Stakeholder',
				stakeholders_long: 'Stakeholder-Projekt',
				stakeholders_explanation: 'Kräfte vor Ort ausrichten',
				risks: 'Risiken',
				risks_long: 'Risiko-Projekt',
				risks_explanation: 'Verwandeln Sie Ihre Risiken in Öffnungen',
				pro: 'Strategieausführung',
				pro_long: 'Strategieausführungs-Projekt',
				pro_explanation: 'Mit Agilität implementieren'
			},
			ai: {
				scenarios: {
					title: "Zu erkundende Szenarien",
					hint: "Werden von der privaten KI verarbeitet — keine Datenübertragung nach außen. Sie können Text und Zeithorizont anpassen, Szenarien hinzufügen oder entfernen.",
					worst_label: "Schlimmster Fall",
					worst_default: "Hauptrisiken materialisieren sich, Chancen werden verpasst, Stakeholder leisten Widerstand.",
					best_label: "Bester Fall",
					best_default: "Risiken werden bewältigt, Chancen genutzt, Stakeholder kooperieren.",
					add: "Szenario hinzufügen",
					remove: "Dieses Szenario entfernen",
					label_placeholder: "Name des Szenarios",
					content_placeholder: "Hypothesen, Schlüsselereignisse, Eintrittsbedingungen…"
				},
				horizon_unit: {
					d: "Tage",
					w: "Wochen",
					m: "Monate",
					y: "Jahre"
				}
			},
		},
		messages: {
			delete_confirmation: 'Projekt löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie das Projekt "{{name}}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
			clone_confirmation: 'Projekt klonen',
			clone_confirmation_explanation:
				'Sind Sie sicher, dass Sie dieses Projekt klonen möchten?',
			clone_in_progress: 'Wir klonen Ihr Projekt, bitte warten...',
			delete_in_progress: 'Wir löschen Ihr Projekt, bitte warten...'
		},
		actions: {
			edit: 'Projektdetails bearbeiten',
			delete: 'Projekt löschen',
			clone: 'Projekt klonen',
			open: 'Projekt öffnen'
		}
	},
	option: {
		fields: {
			name_explanation: 'Bitte geben Sie einen Namen für diese Option ein'
		}
	},
	item: {
		name: 'Interessengruppe',
		name_plural: 'Interessengruppen',
		activeness_zones: {
			external_outer_positive: 'Neutral',
			external_inner_positive: 'Inaktiv',
			external_outer_negative: 'Neutral',
			external_inner_negative: 'Inaktiv',

			internal_low_positive: 'Niedrig',
			internal_medium_positive: 'Mittel',
			internal_high_positive: 'Hoch',
			internal_low_negative: 'Niedrig',
			internal_medium_negative: 'Mittel',
			internal_high_negative: 'Hoch',

			internal_positive: 'Katalysatoren',
			internal_negative: 'Inhibitoren'
		},
		messages: {
			delete_confirmation: 'Interessengruppe löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie diese Interessengruppe löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und wirkt sich auf alle Szenarien aus.\n\nWenn Sie die Interessengruppe nur für dieses Szenario ausblenden möchten, schließen Sie dieses Fenster, wählen Sie die Interessengruppe und klicken Sie in der rechten Spalte auf die "Auge"-Schaltfläche, um sie für dieses Szenario zu deaktivieren.'
		},
		fields: {
			name: 'Name',
			description: 'Beschreibung',
			links: {
				outcoming: {
					name: 'Ausgehende Links'
				},
				incoming: {
					name: 'Eingehende Links'
				}
			},
			stakes: {
				name: 'Interessen-Beziehungen'
			},
			indicators: {
				name: 'Indikator-Beziehungen'
			},
			risks: {
				name: 'Risiko-Beziehungen'
			},
			opportunities: {
				name: 'Öffnungsbeziehungen'
			},
			impact: {
				label: 'Wichtigkeit',
				level: {
					low: 'Niedrig',
					medium: 'Mittel',
					high: 'Hoch'
				}
			},
			trend: {
				label: 'Tonalität',
				level: {
					green: 'Positiv',
					neutral: 'Neutral',
					orange: 'Gefährdet',
					red: 'Negativ'
				}
			}
		},
		actions: {
			create_new: 'Interessengruppe erstellen',
			edit: 'Details bearbeiten',
			delete: 'Interessengruppe löschen',
			clone: 'Interessengruppe klonen'
		},
		no_x: 'Kein Stakeholder',
		engagement: 'Engagement',
		importance: 'Wichtigkeit',
		trust: 'Tonalität',
		levels: {
			low: 'Niedrig',
			medium: 'Mittel',
			high: 'Hoch',
			inactive_neutral: 'Inaktiv / Neutral',
			positive: 'Positiv',
			positive_short: 'Pos.',
			negative: 'Negativ',
			negative_short: 'Neg.',
			at_risk: 'Gefährdet',
			neutral: 'Neutral'
		}
	},
	item_link: {
		no_x: 'Kein Link',
		actions: {
			create_new: 'Neuen Link erstellen'
		}
	},
	item_comment: {
		no_x: 'Kein Verlauf',
		actions: {
			create_new: 'Neuen Verlauf erstellen'
		}
	},
	tag: {
		name: 'Tag',
		name_plural: 'Tags',
		fields: {
			name: 'Tag',
			name_plural: 'Tags'
		},
		messages: {
			delete_confirmation: 'Tag löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie diesen Tag löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
			no_x: 'Kein Tag'
		},
		actions: {
			add_x: 'Tag hinzufügen',
			create_new: 'Tag erstellen',
			edit: 'Tag bearbeiten',
			delete: 'Tag löschen'
		}
	},
	stake: {
		no_x: 'Kein Interesse',
		name: 'Interesse',
		name_plural: 'Interessen',
		fields: {
			name: 'Name',
			reference: 'Referenz',
			name_plural: 'Interessen',
			description: 'Beschreibung',
			evaluated_at: 'Letzte Bewertung',
			weight: 'Gewichtung',
			trend: 'Status',
			risks: {
				name: 'Risiko-Beziehungen',
				name_positive: 'Öffnungs-Beziehungen'
			},
			trend_tier: {
				strained: 'Prekär',
				mixed: 'Gemischt',
				solid: 'Robust'
			}
		},
		actions: {
			delete: 'Interesse löschen',
			edit: 'Interesse bearbeiten',
			create_new: 'Interesse erstellen'
		},
		message: {
			no_x: 'Kein Interesse'
		},
		messages: {
			delete_confirmation: 'Interesse löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie dieses Interesse löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und wirkt sich auf alle Szenarien aus.\n\nWenn Sie das Interesse nur für dieses Szenario ausblenden möchten, schließen Sie dieses Fenster, wählen Sie das Interesse und klicken Sie in der rechten Spalte auf die "Auge"-Schaltfläche, um es für dieses Szenario zu deaktivieren.'
		}
	},

	indicator: {
		name: 'Indikator',
		name_plural: 'Indikatoren',
		no_x: 'Kein Indikator',
		fields: {
			indicator_category: 'Kategorie',
			name: 'Name',
			reference: 'Referenz',
			name_plural: 'Indikatoren',
			evaluated_at: 'Letzte Bewertung',
			frequency: 'Häufigkeit',
			weight: 'Gewichtung',
			description: 'Beschreibung'
		},
		action: {
			add_x: 'Indikatorpunkt hinzufügen'
		},
		message: {
			no_x: 'Kein Indikator'
		},
		messages: {
			delete_confirmation: 'Indikator löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie diesen Indikator löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und wirkt sich auf alle Szenarien aus.\n\nWenn Sie den Indikator nur für dieses Szenario ausblenden möchten, schließen Sie dieses Fenster, wählen Sie den Indikator und klicken Sie in der rechten Spalte auf die "Auge"-Schaltfläche, um ihn für dieses Szenario zu deaktivieren.'
		},
		actions: {
			delete: 'Indikator löschen',
			edit: 'Indikator bearbeiten',
			create_new: 'Indikator erstellen'
		}
	},

	scenario: {
		name: 'Szenario',
		name_plural: 'Szenarien',
		no_x: 'Kein Szenario',
		baseline: 'Baseline',
		fields: {
			name: 'Name',
			name_long: 'Szenario-Name',
			score: 'Szenario-Bewertung',
			description: 'Beschreibung',
			impacts: 'Auswirkungen-Beschreibung',
			generate_simulation: 'Simulation automatisch generieren',
			simulation_query: 'Hypothese und Zeithorizont'
		},
		placeholders: {
			simulation_query:
				'Z. B.: Was würde passieren, wenn der Ölpreis innerhalb von 2 Jahren um 50 % stiege? Welche Folgen für Stakeholder und identifizierte Risiken?'
		},
		messages: {
			delete_confirmation: 'Szenario löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie dieses Szenario löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
			creation_in_progress:
				'Bitte warten Sie, während Ihr Szenario vorbereitet wird...',
			switch_scenario:
				'Zur Baseline oder einem anderen Szenario wechseln',
			simulation_explanation:
				'Die KI analysiert Ihre Hypothese und schlägt Änderungen an Stakeholdern, Risiken und Schlüsselthemen vor, um dieses Szenario zu simulieren.',

			promote_as_baseline: {
				title: 'Dieses Szenario als neue Baseline fördern',
				explanation:
					'Sind Sie sicher, dass Sie das Szenario "<0>{{name}}</0>" als neue Baseline fördern möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
				keep_current_baseline_as_scenario_question:
					'Was möchten Sie mit der vorherigen Baseline machen?',
				keep_current_baseline_as_scenario_question_yes:
					'Ich möchte sie behalten und ihr den folgenden Namen geben',
				keep_current_baseline_as_scenario_question_no:
					'Nichts, sie kann gelöscht werden',
				keep_scenario_question:
					'Möchten Sie eine Kopie des jetzt als neue Baseline geförderten Szenarios behalten?',
				keep_scenario_question_yes: 'Ja, Kopie behalten',
				keep_scenario_question_no: 'Nein, ich brauche keine Kopie',
				loading: 'Szenario wird als neue Baseline gefördert...'
			},

			best_evaluation: 'Bester Fall über alle Szenarien'
		},
		actions: {
			create_new: 'Neues Szenario erstellen',
			create_new_from_baseline: 'Neues Szenario aus Baseline erstellen',
			save_as_new_baseline: 'Als neue Baseline speichern',
			clone: 'Szenario klonen',
			edit: 'Szenario bearbeiten',
			delete: 'Szenario löschen',
			next: 'Zum nächsten Szenario',
			previous: 'Zum vorherigen Szenario',
			previous_baseline: 'Zur Baseline-Szenario'
		}
	},
	fishbone_branch: {
		name: 'Knochen',
		name_plural: 'Knochen',
		fields: {
			completion: 'Vollständigkeit',
			trend: 'Status',
			name: 'Name',
			description: 'Beschreibung',
			weight: 'Gewichtung',
			responsible: 'Verantwortlich',
			dates: 'Daten',
			startOn: 'Start',
			endOn: 'Ende'
		},
		messages: {
			delete_confirmation: 'Fishbone-Zweig löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie diesen Zweig löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und wirkt sich auf alle Szenarien aus.\n\nWenn Sie den Zweig nur für dieses Szenario ausblenden möchten, schließen Sie dieses Fenster, wählen Sie den Zweig und klicken Sie in der rechten Spalte auf die "Auge"-Schaltfläche, um ihn für dieses Szenario zu deaktivieren.'
		},
		actions: {
			add: 'Knochen hinzufügen',
			clone: 'Knochen klonen',
			edit: 'Knochen bearbeiten',
			delete: 'Knochen löschen'
		}
	},
	fishbone_item: {
		name: 'Unterknochen',
		name_plural: 'Unterknochen',
		fields: {
			name: 'Name',
			description: 'Beschreibung',
			completion: 'Fertigstellung',
			trend: 'Status',
			weight: 'Gewichtung',
			responsible: 'Verantwortlich',
			startOn: 'Start',
			endOn: 'Ende',
			dates: 'Daten'
		},
		messages: {
			delete_confirmation: 'Unterknochen löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie diese Maßnahme löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und wirkt sich auf alle Szenarien aus.\n\nWenn Sie die Maßnahme nur für dieses Szenario ausblenden möchten, schließen Sie dieses Fenster, wählen Sie die Maßnahme und klicken Sie in der rechten Spalte auf die "Auge"-Schaltfläche, um sie für dieses Szenario zu deaktivieren.'
		},
		actions: {
			add: 'Unterknochen hinzufügen',
			clone: 'Unterknochen klonen',
			edit: 'Unterknochen bearbeiten',
			delete: 'Unterknochen löschen'
		}
	},
	risk: {
		name: 'Risiko',
		name_plural: 'Risiken',
		name_positive: 'Öffnung',
		name_plural_positive: 'Öffnungen',
		fields: {
			name: 'Name',
			description: 'Beschreibung - Auftretensindikatoren',
			reference: 'Referenz',
			risk_category: 'Kategorie',
			likelihood: 'Wahrscheinlichkeit',
			likelihood_level: 'Bezeichnung Wahrscheinlichkeitsstufe',
			impact: 'Auswirkung',
			impact_level: 'Bezeichnung Auswirkungsstufe',
			matching_opportunity: 'Öffnung',
			matching_risks: 'Risikobeziehungen',
			evaluated_at: 'Letzte Bewertung',
			exposure: 'Exposition',
			exposure_positive: 'Potenzial',

			opportunity: {
				name: 'Öffnung'
			}
		},
		messages: {
			delete_confirmation: 'Risiko löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie dieses Risiko löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und wirkt sich auf alle Szenarien aus.\n\nWenn Sie das Risiko nur für dieses Szenario ausblenden möchten, schließen Sie dieses Fenster, wählen Sie das Risiko und klicken Sie in der rechten Spalte auf die "Auge"-Schaltfläche, um es für dieses Szenario zu deaktivieren.',
			delete_opening: 'Öffnung löschen',
			delete_opening_explanation:
				'Sind Sie sicher, dass Sie diese Öffnung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und wirkt sich auf alle Szenarien aus.\n\nWenn Sie die Öffnung nur für dieses Szenario ausblenden möchten, schließen Sie dieses Fenster, wählen Sie die Öffnung und klicken Sie in der rechten Spalte auf die "Auge"-Schaltfläche, um sie für dieses Szenario zu deaktivieren.',
			no_x: 'Kein Risiko',
			no_category: 'Keine Kategorie',
			no_x_positive: 'Keine Öffnung'
		},
		impacts: {
			1: 'Vernachlässigbar',
			2: 'Gering',
			3: 'Moderat',
			4: 'Hoch',
			5: 'Extrem'
		},
		likelihoods: {
			1: 'Sehr unwahrscheinlich',
			2: 'Unwahrscheinlich',
			3: 'Möglich',
			4: 'Wahrscheinlich',
			5: 'Fast sicher'
		},
		actions: {
			create_new: 'Neues Risiko oder Öffnung erstellen',
			edit: 'Risiko bearbeiten',
			edit_opportunity: 'Öffnung bearbeiten',
			delete: 'Risiko löschen',
			delete_opportunity: 'Öffnung löschen'
		}
	},
	risk_category: {
		name: 'Kategorie',
		name_plural: 'Kategorien',
		fields: {
			name: 'Name'
		},
		messages: {
			delete_confirmation: 'Kategorie löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie diese Kategorie löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
			no_x: 'Keine Kategorie'
		},
		actions: {
			create_new: 'Neue Kategorie erstellen',
			edit: 'Kategorie bearbeiten',
			delete: 'Kategorie löschen',
			add_x: 'Kategorie hinzufügen'
		},
		default_values: {
			name: {
				1: 'Existenziell',
				2: 'Strategisch',
				3: 'Operativ'
			}
		}
	},
	indicator_category: {
		name: 'Kategorie',
		name_plural: 'Kategorien',
		fields: {
			name: 'Name'
		},
		messages: {
			delete_confirmation: 'Kategorie löschen',
			delete_confirmation_explanation:
				'Sind Sie sicher, dass Sie diese Kategorie löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
			no_x: 'Keine Kategorie',
			unassigned: 'Nicht zugewiesen'
		},
		actions: {
			create_new: 'Neue Kategorie erstellen',
			edit: 'Kategorie bearbeiten',
			delete: 'Kategorie löschen',
			add_x: 'Kategorie hinzufügen'
		},
		default_values: {
			name: {
				1: 'Finanzen',
				2: 'Kunden',
				3: 'Interne Prozesse',
				4: 'Lernen und Wachstum'
			}
		}
	},
};
